import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const Review = ({ children }) => (
  <div className="flex size-10 items-center justify-center gap-x-1">
    <Icon
      className="text-rd-primary-700 dark:text-rd-primary-700"
      name="rating-star"
    />
    <Text
      as="span"
      className="text-rd-primary-700 dark:text-rd-primary-700"
      size="size2"
      type="primary"
      bold
    >
      {children}
    </Text>
  </div>
);

Review.propTypes = {
  children: PropTypes.number.isRequired,
};

export default Review;
